import { SERVER_API } from "../../Constant";
import axios from "axios";

// Fetch Products (just product list, no stock info)
export const FetchProducts_api = async (
  page: number,
  limit: number,
  search: string,
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Products/fetch_products.php`,
      {
        params: { page, limit, search },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch products failed:", error);
    return { error: "Fetch products failed" };
  }
};

// Fetch Product Stock (for viewing stock levels)
export const FetchProductStock_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Products/fetch_product_stock.php`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch product stock failed:", error);
    return { error: "Fetch product stock failed" };
  }
};

// Add Product
export const AddProduct_api = async (inputs: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(inputs));

    const response = await axios.post(
      `${SERVER_API}/Products/add_product.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add product failed:", error);
    return { error: "Add product failed" };
  }
};

// Fetch Products With Stock (for management page)
export const FetchProductsWithStock_api = async (search: string = "") => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Products/fetch_products_with_stock.php`,
      {
        params: { search },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch products with stock failed:", error);
    return { error: "Fetch products with stock failed" };
  }
};

// Update Product
export const UpdateProduct_api = async (inputs: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(inputs));

    const response = await axios.post(
      `${SERVER_API}/Products/update_product.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update product failed:", error);
    return { error: "Update product failed" };
  }
};

// Update Product Status
export const UpdateProductStatus_api = async (inputs: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(inputs));

    const response = await axios.post(
      `${SERVER_API}/Products/update_product_status.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update product status failed:", error);
    return { error: "Update product status failed" };
  }
};

// Update Stock Status
export const UpdateStockStatus_api = async (inputs: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(inputs));

    const response = await axios.post(
      `${SERVER_API}/Products/update_stock_status.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update stock status failed:", error);
    return { error: "Update stock status failed" };
  }
};
